/**
 * Created by Jerker Nord on 2020-08-07.
 */
import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {MonkeysGoldParsedInitData} from "../server/data/MonkeysGoldParsedInitData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {MonkeysGoldGameConfig} from "../MonkeysGoldGameConfig";

export class MonkeysGoldReelAreaView extends ReelAreaView {

    private _backgroundGFXContainer:PIXI.Container;
    private _backgroundLeftMainGameContainer:PIXI.Container;
    private _backgroundRightMainGamnContainer:PIXI.Container;
    private _backgroundLeftBonusGameContainer:PIXI.Container;
    private _backgroundRightBonusGameContainer:PIXI.Container;
    private _backgroundLeftMainGame:PIXI.Sprite;
    private _backgroundRightMainGame:PIXI.Sprite;
    private _backgroundLeftBonusGame:PIXI.Sprite;
    private _backgroundRightBonusGame:PIXI.Sprite;

    private static LEFT_POSITION:PIXI.Point = new PIXI.Point(-114, 86);
    private static RIGHT_POSITION:PIXI.Point = new PIXI.Point(696, 76);

    constructor(resourcesGroup?:ResourcesGroupName) {
        super(resourcesGroup);
        this._backgroundGFXContainer = new PIXI.Container();
        this._backgroundLeftMainGameContainer = new PIXI.Container();
        this._backgroundLeftMainGameContainer.position = MonkeysGoldReelAreaView.LEFT_POSITION;
        this._backgroundRightMainGamnContainer = new PIXI.Container();
        this._backgroundRightMainGamnContainer.position = MonkeysGoldReelAreaView.RIGHT_POSITION;
        this._backgroundLeftBonusGameContainer = new PIXI.Container();
        this._backgroundLeftBonusGameContainer.position = MonkeysGoldReelAreaView.LEFT_POSITION;
        this._backgroundRightBonusGameContainer = new PIXI.Container();
        this._backgroundRightBonusGameContainer.position = MonkeysGoldReelAreaView.RIGHT_POSITION;
        this.addFeatureEventHandlers();
    }

    protected onResize(resizeData:IResizeData) {
        super.onResize(resizeData);
        if(resizeData.orientation == Orientation.PORTRAIT) {
            this._backgroundGFXContainer.visible = false;
        } else {
            this._backgroundGFXContainer.visible = true;
        }
    }

    private addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:MonkeysGoldParsedInitData):void {
        if(data.mode == GameMode.FREESPIN || data.mode == GameMode.FREESPIN_AVALANCHE) {
            this.enableBonusGameBackgroundGFX();
        } else {
            this.enableMainGameBackgroundGFX();
        }
    }

    protected initAnimations():void {
        StageManager.getLayer(MonkeysGoldGameConfig.instance.LAYERS.FOREGROUND.name).addChild(this._backgroundGFXContainer);
        this._backgroundGFXContainer.addChild(this._backgroundLeftMainGameContainer);
        this._backgroundLeftMainGame = new PIXI.Sprite(GameResources.getTextures("Main_bg_assets/Main_left")[0]);
        this._backgroundLeftMainGameContainer.addChild(this._backgroundLeftMainGame);
        this._backgroundGFXContainer.addChild(this._backgroundRightMainGamnContainer);
        this._backgroundRightMainGame = new PIXI.Sprite(GameResources.getTextures("Main_bg_assets/Main_right")[0]);
        this._backgroundRightMainGamnContainer.addChild(this._backgroundRightMainGame);

        this._backgroundGFXContainer.addChild(this._backgroundLeftBonusGameContainer);
        this._backgroundLeftBonusGame = new PIXI.Sprite(GameResources.getTextures("FS_bg_assets/Fs_left")[0]);
        this._backgroundLeftBonusGameContainer.addChild(this._backgroundLeftBonusGame);
        this._backgroundGFXContainer.addChild(this._backgroundRightBonusGameContainer);
        this._backgroundRightBonusGame = new PIXI.Sprite(GameResources.getTextures("FS_bg_assets/Fs_right")[0]);
        this._backgroundRightBonusGameContainer.addChild(this._backgroundRightBonusGame);
    }

    public enableBonusGameBackgroundGFX():void {
        this._backgroundLeftBonusGameContainer.visible = true;
        this._backgroundRightBonusGameContainer.visible = true;
        this._backgroundLeftMainGameContainer.visible = false;
        this._backgroundRightMainGamnContainer.visible = false;
    }

    public enableMainGameBackgroundGFX():void {
        this._backgroundLeftBonusGameContainer.visible = false;
        this._backgroundRightBonusGameContainer.visible = false;
        this._backgroundLeftMainGameContainer.visible = true;
        this._backgroundRightMainGamnContainer.visible = true;
    }
}